import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './partenaire.reducer';

export const PartenaireDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const partenaireEntity = useAppSelector(state => state.partenaire.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="partenaireDetailsHeading">
          <Translate contentKey="alexisExportApp.partenaire.detail.title">Partenaire</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{partenaireEntity.id}</dd>
          <dt>
            <span id="nomOuRaisonSociale">
              <Translate contentKey="alexisExportApp.partenaire.nomOuRaisonSociale">Nom Ou Raison Sociale</Translate>
            </span>
          </dt>
          <dd>{partenaireEntity.nomOuRaisonSociale}</dd>
          <dt>
            <span id="tarifDeTransport">
              <Translate contentKey="alexisExportApp.partenaire.tarifDeTransport">Tarif De Transport</Translate>
            </span>
          </dt>
          <dd>{partenaireEntity.tarifDeTransport}</dd>
          <dt>
            <span id="datePersistence">
              <Translate contentKey="alexisExportApp.partenaire.datePersistence">Date Persistence</Translate>
            </span>
          </dt>
          <dd>
            {partenaireEntity.datePersistence ? (
              <TextFormat value={partenaireEntity.datePersistence} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="dateUpdate">
              <Translate contentKey="alexisExportApp.partenaire.dateUpdate">Date Update</Translate>
            </span>
          </dt>
          <dd>
            {partenaireEntity.dateUpdate ? <TextFormat value={partenaireEntity.dateUpdate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
        </dl>
        <Button tag={Link} to="/partenaire" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/partenaire/${partenaireEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PartenaireDetail;
